module.exports = __webpack_public_path__ + "2fd741d95e89a6cec52f8431170b8236.pdf";